
<!-- 
VisitForInfoAJModal.vue
功能：填寫已拜訪或未拜訪
作者：i9400537 盧侑萱
完成：2021-06-21
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 v-if="open" class="modal-title">是否已拜訪回報</h3>
        </div>
        <div style="text-align:center;">
          <div class="radio radio-inline">
            <input type="radio" value="1" v-model="type" id="Yes" data-vv-as="已親晤拜訪回報" />
            <label for="Yes">已拜訪回報</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" value="0" id="No" v-model="type" data-vv-as="未拜訪回報" />
            <label for="No">未拜訪回報</label>
          </div>
        </div>
        <br />
        <div style="text-align:center;">
          <span style="color:red;">提醒您，請確認後再回報喔！！</span>
        </div>
        <br />
        <div style="text-align:center;">
          <button
            v-if="type=='0'||type=='1'"
            type="button"
            class="btn btn-primary"
            @click="nextstep()"
            v-html="'<span style=\'font-size:1rem\'>下一步<span>'"
          ></button>
          <button
            v-else
            type="button"
            class="btn btn-primary"
            :disabled="true"
            v-html="'<span style=\'font-size:1rem\'>下一步<span>'"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "VisitForInfoAJModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    target: Object
  },
  data() {
    return {
      type: String
    };
  },
  methods: {
    //下一步
    nextstep() {
      this.$emit("nextstep", this.type);
      this.type = "";
    }
  }
};
</script>

<style lang="scss" scoped>
#searchclear {
  position: absolute;
  right: 20px;
  top: 10px;
  bottom: 0;
  margin-right: 25px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}
</style>